import { FC, PropsWithChildren, ReactElement, SyntheticEvent } from 'react';

import './TiltedButton.css';

type myProps = {
	variant:
		| 'btn-done'
		| 'btn-not-done'
		| 'btn-qr-landing'
		| 'btn-qr-success'
		| 'btn-logout'
		| 'btn-to-start';
	action: (event: SyntheticEvent<HTMLButtonElement, MouseEvent>) => void;
};
type Props = PropsWithChildren<myProps>;

const TiltedButton: FC<Props> = ({
	variant,
	children,
	action,
}): ReactElement => {
	return (
		<button className={`tilted-btn`} id={variant} onClick={action}>
			{children}
		</button>
	);
};

export default TiltedButton;
